import { gql } from '@apollo/client';
import { spreadGroupedDomains } from '../../react/util';

export const ProductFragments = {
  badges: {
    name: 'BadgeDetails',
    fragment: gql`
        fragment BadgeDetails on Product {
            badges(storeId: $storeId) {
                name
                label
                message
                color
                creativeImageUrl
                endDate
                timerDuration
                __typename
            }
        }
    `
  },
  identifiers: {
    name: 'PrimaryIdentifiers',
    fragment: gql`
        fragment PrimaryIdentifiers on Product {
            identifiers {
                itemId
                modelNumber
                upc
                vendorNumber
                storeSkuNumber
                productLabel
                canonicalUrl
                omsThdSku,
                brandName
                isSuperSku
                parentId
                #brandId
                upcGtin13
                specialOrderSku
                toolRentalSkuNumber
                rentalCategory
                rentalSubCategory
                sampleId
                productType
                isAppliance @client
                __typename
            }
        }`,
  },
  media: {
    name: 'PrimaryMedia',
    fragment: gql`
        fragment PrimaryMedia on Product {
            media {
                image(size: 1000) @client {
                    url
                    sizes
                    type
                    subType
                }
                images {
                    url
                    sizes
                    type
                    subType
                }
                richContent {
                    url
                    displayMode
                    content
                }
                video {
                    url
                    videoStill
                    shortDescription
                    link {
                        url
                        text
                    }
                    longDescription
                    title
                    type
                    videoId
                }
                threeSixty {
                    id
                    url
                }
                augmentedRealityLink {
                    image
                    usdz
                }
                __typename
            }
        }
    `,
  },
  mediaSlim: {
    name: 'PrimaryMediaSlim',
    fragment: gql`
        fragment PrimaryMediaSlim on Product {
            media {
                image(size: 1000) @client {
                    url
                    sizes
                    type
                    subType
                }
                images {
                    url
                    sizes
                    type
                    subType
                }
                __typename
            }
        }
    `,
  },
  details: {
    name: 'PrimaryDetails',
    fragment: gql`
        fragment PrimaryDetails on Product {
            details {
                description
                descriptiveAttributes {
                    name
                    value
                    bulleted
                    sequence
                }
                highlights
                infoAndGuides {
                    name
                    url
                }
                collection {
                    name
                    url
                    type
                    collectionId
                }
                installation {
                  serviceType
                  salient
                  contactNumber
                  leadGenUrl
                  programCategory
                  howToBuy
                }
            }
        }
    `,
  },
  info: {
    name: 'PrimaryInfo',
    fragment: gql`
        fragment PrimaryInfo on Product {
            info {
                applianceBundled
                bareCushion
                calculatorType
                classNumber
                colorNumber
                colorWallEligible
                categoryHierarchy
                consultationType
                displayWhatWeOffer
                dotComColorEligible
                ecoRebate
                fbrItems
                fbtItems
                fiscalYear
                forProfessionalUseOnly
                genericBrand
                genericName
                globalCustomConfigurator {
                    customButtonText,
                    customDescription,
                    customExperience,
                    customTitle,
                    customExperienceUrl
                }
                hasServiceAddOns
                hasSubscription
                hasVisuallySimilar
                hazardCode
                hidePrice
                inStoreAssemblyAvailable
                irgItems
                isBuryProduct
                isGenericProduct
                isLiveGoodsProduct
                isSponsored
                isSureFit
                minimumOrderQuantity
                movingCalculatorEligible
                paintBrand
                productDepartment
                productSubType {
                    link
                    name
                }
                projectCalculatorEligible
                prop65Warning
                protectionPlanSku
                quantityLimit
                recommendationFlags {
                    ACC
                    badges
                    collections
                    featureBasedRecommendations
                    frequentlyBoughtTogether
                    promotionalBundle
                    visualNavigation
                }
                replacementOMSID
                returnable
                sizeChart
                sponsoredBeacon {
                    onClickBeacon
                    onViewBeacon
                }
                sskMax
                sskMin
                swatches {
                    swatchImgUrl
                    value
                    label
                    itemId
                    isSelected
                    url
                }
                subClassNumber
                totalNumberOfOptions
                unitOfMeasureCoverage
                wasMinPriceRange
                wasMaxPriceRange
                label
                productGroup
                isBrioSku @client
                isCustomKitchenCabinet @client
            }
        }
    `
  },
  reviews: {
    name: 'ReviewsDetails',
    fragment: gql`
        fragment ReviewsDetails on Product {
            reviews {
                ratingsReviews {
                    averageRating
                    totalReviews
                }
            }
            __typename
        }
    `
  },
  relatedSearchProducts: {
    name: 'RelatedSearchProducts',
    fragment: gql`
        fragment RelatedSearchProducts on Product {
            relatedSearchProducts {
                br_iuid
                br_related_rid_tag
                hasRelatedProducts
                moreResults {
                    title
                    description
                    image
                    url
                    shortDescription
                    __typename
                }
                related {
                    anchor
                    url
                    __typename
                }
            }
            __typename
        }
    `
  },
  specificationGroup: {
    name: 'SpecificationGroup',
    fragment: gql`
        fragment SpecificationGroup on Product {
            specificationGroup {
                specTitle
                specifications {
                    specName
                    specValue
                }
                __typename
            }
        }
    `
  },
  // installSkus {
  //   serviceType
  //   installRetailPrice
  // }
  // doItForMe {
  //   installProcess
  //   priceIncludes
  // }
  // serviceAddons: {
  //   name: 'ServiceAddonsGroup',
  //   fragment: gql`
  //   fragment ServiceAddonsGroup on Product {
  //     serviceAddons(storeId: $storeId) {
  //       sellFurnishInstall {
  //         installationServiceType
  //         installationProgramCategory
  //         installationContactNumber
  //         dualPathSku
  //       }
  //       proReferrals {
  //         category
  //         serviceIdentifier
  //         serviceName
  //         serviceDisplayName
  //         providers {
  //           provider
  //         }
  //         assemblyCategory
  //         startingPrice
  //         available
  //       }
  //       attachLabors {
  //         installationSku
  //       }
  //       __typename
  //     }
  //   }
  //   `
  // },
  subscription: {
    name: 'SubscriptionDetails',
    fragment: gql`
        fragment SubscriptionDetails on Product {
            subscription {
                defaultfrequency
                discountPercentage
                subscriptionEnabled
                __typename
            }
        }
    `
  },
  taxonomy: {
    name: 'TaxonomyDetails',
    fragment: gql`
        fragment TaxonomyDetails on Product {
            taxonomy {
                brandLinkUrl
                breadCrumbs {
                    dimensionName
                    label
                    url
                    creativeIconUrl
                    deselectUrl
                    refinementKey
                }
            }
        }
    `
  },
  pricing: {
    name: 'PricingDetails',
    fragment: gql`
        fragment PricingDetails on Product {
            pricing(storeId: $storeId) {
                alternate {
                    bulk {
                        pricePerUnit
                        thresholdQuantity
                        value
                    }
                    unit {
                        caseUnitOfMeasure
                        unitsOriginalPrice
                        unitsPerCase
                        value
                    }
                }
                alternatePriceDisplay
                mapAboveOriginalPrice
                message
                original
                promotion {
                    dates {
                        end
                        start
                    }
                    description {
                        shortDesc
                        longDesc
                    }
                    dollarOff
                    isCartLevelPromotion
                    percentageOff
                    promoCode
                    savingsCenter
                    savingsCenterPromos
                    specialBuyDollarOff
                    specialBuyPercentageOff
                    specialBuySavings
                    experienceTag
                    subExperienceTag
                    anchorItemList
                    itemList
                    promotionId
                    reward {
                        tiers {
                            minPurchaseQuantity
                            rewardPercent
                            rewardAmountPerOrder
                            rewardAmountPerItem
                            minPurchaseAmount
                        }
                    }
                    type
                }
                specialBuy
                unitOfMeasure
                value
                __typename
            }
        }
    `
  },
  keyProductFeatures: {
    name: 'KeyProductFeatureDetails',
    fragment: gql`
        fragment KeyProductFeatureDetails on Product {
            keyProductFeatures(maxFeatures: $maxFeatures) {
                keyProductFeaturesItems {
                    itemId
                    features {
                        name
                        value
                        refinementId
                        refinementUrl
                    }
                }
            }
        }
    `
  },
  availabilityType: {
    name: 'AvailabilityType',
    fragment: gql`
        fragment AvailabilityType on Product {
            availabilityType {
                discontinued
                buyable
                status
                type
                isFulfillableIRGSku @client
            }
        }
    `
  },
  installServices: {
    name: 'InstallServices',
    fragment: gql`
        fragment InstallServices on Product {
            installServices(storeId: $storeId) {
                scheduleAMeasure
                scheduleAnAppointment
            }
        }
    `
  },
  favoriteDetail: {
    name: 'FavoriteDetail',
    fragment: gql`
        fragment FavoriteDetail on Product {
            favoriteDetail {
                count
            }
        }
    `
  },
  fulfillment: {
    name: 'FulfillmentDetails',
    fragment: gql`
        fragment FulfillmentDetails on Product {
            fulfillment(storeId: $storeId, zipCode: $zipCode) {
                backordered
                backorderedShipDate
                excludedShipStates
                bossExcludedShipStates
                seasonStatusEligible
                bodfsAssemblyEligible
                inStoreAssemblyEligible
                onlineStoreStatusType
                anchorStoreStatusType
                onlineStoreStatus
                anchorStoreStatus
                fulfillmentOptions {
                    type
                    fulfillable
                    services {
                        type
                        mode {
                            code
                            desc
                            longDesc
                            group
                        }
                        isDefault
                        deliveryCharge
                        freeDeliveryThreshold
                        itemLevelFreeShipping
                        hasFreeShipping
                        dynamicEta {
                            hours
                            minutes
                            __typename
                        }
                        deliveryTimeline
                        deliveryDates {
                            startDate
                            endDate
                            __typename
                        }
                        locations {
                            type
                            isAnchor
                            locationId
                            storeName
                            storePhone
                            state
                            distance
                            curbsidePickupFlag
                            isBuyInStoreCheckNearBy
                            inventory {
                                quantity
                                isInStock
                                isOutOfStock
                                isLimitedQuantity
                                isUnavailable
                                maxAllowedBopisQty
                                minAllowedBopisQty
                                __typename
                            }
                            __typename
                        }
                        __typename
                    }
                    messages
                    __typename
                }

                isBODFS @client
                bodfs @client
                isBOPIS @client
                bopis @client
                isBOSS @client
                boss @client
                isCurrentlyUnavailable @client
                isOutOfStockOnline @client
                isSTH @client
                shipToHome @client
                isFulfillable @client
                storeType @client
                __typename
            }
            __typename
        }
    `
  },
  sizeAndFitDetail: {
    name: 'SizeAndFitDetail',
    fragment: gql`
        fragment SizeAndFitDetail on Product {
            sizeAndFitDetail {
                attributeGroups {
                    dimensionLabel
                    attributes {
                        attributeName
                        dimensions
                        __typename
                    }
                    productType
                    __typename
                }
                __typename
            }
            __typename
        }
    `
  }
};

export const getProductFragment = ({ domains }) => {
  let fragmentDomains = domains;

  if (fragmentDomains.length === 0) {
    fragmentDomains = [
      'identifiers',
      'media',
      'details',
      'reviews',
      'info',
      'specificationGroup',
      'taxonomy',
      'sizeAndFitDetail'
    ];
  }
  const AVAILABLE_DOMAINS = Object.keys(ProductFragments);
  const missingDomains = fragmentDomains.filter((domain) => AVAILABLE_DOMAINS.indexOf(domain) === -1);
  if (missingDomains.length) {
    throw new Error(`The following product domains do not exist: ${missingDomains.join(', ')}.`);
  }

  return {
    queryUnwrapped: `
      ${fragmentDomains.map((domain) => `...${ProductFragments[domain].name}`)
    .join('\n')}
      itemId
      dataSources
      isBrowseOnly @client
      fulfillmentMethod @client
      __typename
    `,
    query: `
        ${fragmentDomains.map((domain) => `...${ProductFragments[domain].name}`)
    .join('\n')}
        itemId
        dataSources
        isBrowseOnly @client
        fulfillmentMethod @client
         __typename
      `,
    fragments: fragmentDomains
      .map((domain) => ProductFragments[domain].fragment.loc.source.body)
      .join('\n ')
  };
};

export const queryRequiresStoreId = ({ domains }) => {
  const storeIdDomains = ['badges', 'pricing', 'fulfillment', '$ProductPod'];
  const storeIdDomainCount = domains.reduce((acc, domain) => (
    acc + (storeIdDomains.indexOf(domain) > -1 ? 1 : 0)
  ), 0);
  return storeIdDomainCount > 0;
};

export const queryRequiresZipCode = ({ domains }) => {
  const zipCodeDomains = ['fulfillment', '$ProductPod'];
  const zipCodeDomainCount = domains.reduce((acc, domain) => (
    acc + (zipCodeDomains.indexOf(domain) > -1 ? 1 : 0)
  ), 0);
  return zipCodeDomainCount > 0;
};

const getProductQuery = ({ domains: initialDomains = [], multiple = false, alias = 'default', skip } = {}) => {
  const domains = spreadGroupedDomains({ domains: initialDomains });
  const params = ['$dataSource: String'];
  if (multiple) {
    params.push('$itemIds: [String!]!');
  } else {
    params.push('$itemId: String!');
  }

  if (queryRequiresStoreId({ domains })) {
    params.push('$storeId: String');
  }

  if (queryRequiresZipCode({ domains })) {
    params.push('$zipCode: String');
  }

  if (domains.indexOf('keyProductFeatures') > -1) {
    params.push('$maxFeatures: Int = 8');
  }

  const fragments = getProductFragment({ domains });

  // leave empty blank lines
  const query = `
  query ProductModel(${params.join(', ')}) {
    ${multiple
    ? 'products(dataSource: $dataSource, itemIds: $itemIds) {'
    : 'product(dataSource: $dataSource, itemId: $itemId) {'}
      itemId
      ${fragments.query}
    }
  }
  ${fragments.fragments}
  `;

  if (skip) {
    return gql('{__typename}');
  }

  return gql(query);
};

export default getProductQuery;
